export const formatClientName = (client) => {
  if (!client) return '-';
  const { initials, lastNamePrefix, lastName } = client;
  return lastNamePrefix?.length > 0 
    ? `${initials} ${lastNamePrefix} ${lastName}`
    : `${initials} ${lastName}`;
};

export const formatMeasurement = (value, unit) => {
  return value ? `${value}${unit}` : '-';
};